import { useState } from "react";
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";

const SelectFilterShopify = ({
  defaultSelectedItem,
  data,
  onSelect,
}: {
  defaultSelectedItem: any;
  data: any;
  onSelect: Function;
}) => {
  const [showOptionList, setShowOptionList] = useState(false);
  const [selectedItem, setSelectedItem] = useState(defaultSelectedItem);

  const handleListDisplay = () =>
    setShowOptionList((showOptionList) => !showOptionList);

  const handleOnSelect = (item: any) => {
    setShowOptionList(false);
    setSelectedItem(item);
    onSelect(item);
  };

  return (
    <div className="relative w-80 ml-3">
      <div
        className={`flex flex-row bg-neutral-600 w-full pl-6 pr-4 py-4 ${
          showOptionList ? "rounded-t-lg" : "rounded-lg"
        } items-center`}
        onClick={handleListDisplay}
      >
        <span className="flex flex-1 text-gray-300">{selectedItem}</span>
        {showOptionList ? (
          <AiFillCaretUp fill="#d4d4d8" size={18} />
        ) : (
          <AiFillCaretDown fill="#d4d4d8" size={18} />
        )}
      </div>
      {showOptionList && (
        <ul className="absolute top-full left-0 mt-2 w-full cursor-pointer bg-neutral-600 divide-y rounded-lg border-t overflow-y-auto h-96">
          {data?.map((item: any) => (
            <li
              className={`${
                selectedItem?.key === item
                  ? "text-gray-300"
                  : "text-gray-300 font-medium"
              } pl-6 p-4`}
              data-name={item}
              key={item}
              onClick={() => handleOnSelect(item)}
            >
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SelectFilterShopify;
